// This hook aims to fetch stripe products list
// Even if products are not used on this page, it will reduce spinners time on /profile and /abonnement pages when user navigates there

import {useEffect} from 'react';

import useAuth from '../../providers/useAuth';
import usePayment from '../../providers/usePayment';
import useProfile from '../../providers/useProfile';

const useFetchProductsList = () => {
  const auth = useAuth();
  const {getProductsList, products, productsLoading} = usePayment();
  const {isPartner} = useProfile();

  useEffect(() => {
    (async () => {
      // Businness rule, we do not need to get products for partners because they cannot access products page
      const shouldGetProductsList = !isPartner;
      if (products?.length < 1 && !productsLoading && shouldGetProductsList) {
        getProductsList();
      }
    })();
  }, [auth?.user?.tokenAad]);
};

export default useFetchProductsList;
